import { ajax } from 'utils';
// @ts-ignore
import _ from 'lodash';
import { QueryField } from 'modules/types/commons/Query';
import { WorkBenchMenuKey } from '../types/workbench';
import { hasGrayConfigWithoutGroup } from 'utils/gray';
import * as api from 'services/javaApi';

export const LOADING = 'mpc/external/outWorkbench/list_loading';
export const GET_LIST_SUCCESS = 'mpc/external/outWorkbench/get_list_success';
export const GET_LIST_OPTIONS_SUCCESS = 'mpc/external/outWorkbench/get_list_options_success';
export const CHANGE_CONDITIONS = 'mpc/external/outWorkbench/change_conditions';
export const CHANGE_CHECK = 'mpc/external/outWorkbench/change_check';
export const CHANGE_LIST_FINISH_TYPE =
  'mpc/external/outWorkbench/change_list_finish_type';

export interface GetListSuccess extends WorkBenchMenuKey {
  type: typeof GET_LIST_SUCCESS;
  data?: any;
}

export interface GetListOptionsSuccess extends WorkBenchMenuKey {
  type: typeof GET_LIST_OPTIONS_SUCCESS;
  data?: QueryField[];
}

export interface ChangeConditions extends WorkBenchMenuKey {
  type: typeof CHANGE_CONDITIONS;
  data?: any;
}

export interface Loading extends WorkBenchMenuKey {
  type: typeof LOADING;
}

export interface ChangeCheck extends WorkBenchMenuKey {
  type: typeof CHANGE_CHECK;
  data?: any;
}

export interface ChangeListFinishType extends WorkBenchMenuKey {
  type: typeof CHANGE_LIST_FINISH_TYPE;
  data?: any;
}

export type WorkbenchActions =
  | GetListSuccess
  | Loading
  | GetListOptionsSuccess
  | ChangeConditions
  | ChangeCheck
  | ChangeListFinishType;

export function changeCheck(menuKey: string, data: any) {
  return {
    type: CHANGE_CHECK,
    data: { menuKey, data },
    menuKey,
  };
}

export function changeConditions(conditions: any = {}) {
  return {
    type: CHANGE_CONDITIONS,
    data: conditions,
  };
}

function getJavaCompatibleListResponse(res: any) {
  const { data } = res;
  const {
    columns,
    current = 1,
    limit = 15,
    list = [],
    total_count = 0,
    total_page = 1,
  } = data;
  const newResData = {
    columns: (columns || []).map((item: any) => {
      let key = item.key;

      if (key === 'quote_deadline') {
        key = 'formatted_quote_deadline';
      }

      return { ...item, key };
    }),
    current_page: current,
    page_size: limit,
    res: (list || []).map((item: any) => ({
      ...item,
      formatted_quote_deadline: item.quote_deadline,
      ['can_move_wb?']: item.can_move_wb,
    })),
    total_count,
    total_page,
  };

  res.data = newResData;
  res.data_ori = data;
}

function getJavaCompatibleListRequestBody(
  menuKey: string,
  conditions: any = {},
  pagination = {},
) {
  const { wb_products, plan_users } = (conditions || {}) as any;
  const { current_page = 1, page_size = 15 } = (pagination || {}) as any;
  const body = {
    current: current_page,
    size: page_size,
    conditions: {
      ...conditions,
      product: wb_products,
      demand_plan_users: plan_users,
      wb_products: undefined,
      plan_users: undefined,
    },
    state: _.snakeCase(menuKey).toUpperCase(),
  };

  return body;
}

function getListWithGray(menuKey: string, conditions: any = {}, pagination = {}) {
  return {
    types: [LOADING, GET_LIST_SUCCESS, null],
    promise: () => ajax({
      url: 'outsource/v2/java_proxy/workbenches/list',
      method: 'POST',
      body: getJavaCompatibleListRequestBody(menuKey, conditions, pagination),
    }).then((res: any) => {
      getJavaCompatibleListResponse(res);
      return { data: { list: res.data, conditions, menuKey } };
    }),
    menuKey,
  };
}

export function getList(menuKey: string, conditions: any = {}, pagination = {}) {
  if (hasGrayConfigWithoutGroup(['external.my_workbenches.list'])) {
    return getListWithGray(menuKey, conditions, pagination);
  }

  return {
    types: [LOADING, GET_LIST_SUCCESS, null],
    promise: () => ajax({
      url: `outsource/v2/my_workbenches/${_.snakeCase(menuKey)}`,
      method: 'POST',
      body: { conditions, ...pagination },
    }).then((res: any) => {
      return { data: { list: res.data, conditions, menuKey } };
    }),
    menuKey,
  };
}

export function getFilterOptions(menuKey: string, keys: string[]) {
  return {
    types: [null, GET_LIST_OPTIONS_SUCCESS, null],
    promise: () => api.outsourceCommonFilterOptions({
      keys,
      state: _.snakeCase(menuKey),
      data: keys.reduce((prev: any, curr: string) => {
        prev[curr] = { out: true };
        return prev;
      }, {}),
    }),
    menuKey,
  };
}

export function changeListFinishType(data: any) {
  return {
    type: CHANGE_LIST_FINISH_TYPE,
    data,
  };
}
